function _datediff(date, otherDate) {
    try {
        return Math.ceil(Math.abs(date - otherDate) / (1000 * 60 * 60 * 24));
    } catch (err) {
        return 0;
    }
}

export default _datediff;


